import { LinkCard, LinkCardGrid } from '../../components/LinkCard';
import { Markdown } from '../../components/Markdown';
import { PageHeader } from '../../components/PageHeader';
import { useDict } from '../../i18n/dictionary';
import { useLocale } from '../../lib/locale';
import { usePageTitle } from '../../lib/page';
import { ag5Dict } from './i18n';
import { AG5_SCRIPTS } from './scripts';

/**
 * App landing page: the same registry the sidebar renders, with room for each
 * script's description so a script can be picked without opening it first.
 */
export function Ag5ScriptList() {
  const t = useDict(ag5Dict);
  const { locale } = useLocale();
  usePageTitle(t.scriptsTitle);

  return (
    <>
      <PageHeader title={t.scripts} />
      <LinkCardGrid>
        {AG5_SCRIPTS.map((script) => {
          const text = script.text[locale];
          return (
            <LinkCard
              key={script.slug}
              to={`/ag5/scripts/${script.slug}`}
              title={text.title}
            >
              <Markdown>{text.description}</Markdown>
            </LinkCard>
          );
        })}
      </LinkCardGrid>
    </>
  );
}
